import { FC } from "react";
import CustomPopup from "../../../../components/CustomPopup/CustomPopup";
import useWindowSize from "../../../../hooks/useWindowSize";
import { Colors } from "../../../../styles/constant";
import { tabViewPoint } from "../../../../utils/constants";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Button, Stack, Typography } from "@mui/material";
import successGif from "../../../../assets/gif/Success.json";
import CommonGifAnimation from "../../../../components/CustomGifAnimation/CommonGifAnimation";
import { T_AnimationData } from "../../../../globalTypes/GlobalTypes";
import "./LeadIntentPopup.scss";
import { useAppTranslation } from "../../../../hooks/useAppTranslation";

interface Props {
  open: boolean;
  handleOpen: any;
}

const LeadIntentConfirmationPopup: FC<Props> = ({ open, handleOpen }) => {
  const { width } = useWindowSize();
  const { t } = useAppTranslation("common");

  return (
    <CustomPopup
      open={open}
      handleOpen={handleOpen}
      btnLabel={t("home.actionButtons.goBack")}
      className={`lead-intent-confirmation-popup ${width < tabViewPoint ? "" : "for-web"}`}
      btnStartIcon={
        <ChevronLeftIcon fontSize="small" sx={{ color: Colors.red }} />
      }
      transitionType="slide"
    >
      <Stack rowGap="2rem">
        <Stack
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          rowGap=".625rem"
        >
          <CommonGifAnimation
            width="16.875rem"
            animationData={successGif as T_AnimationData}
          />{" "}
          <Typography variant="h3">
            {t("home.leadIntent.confirmation.title")}
          </Typography>
          <Typography variant="subtitle2">
            {t("home.leadIntent.confirmation.subtitle")}
          </Typography>
        </Stack>
        <Button fullWidth variant="contained" onClick={() => handleOpen(false)}>
          {t("home.actionButtons.done")}
        </Button>
      </Stack>
    </CustomPopup>
  );
};

export default LeadIntentConfirmationPopup;
